/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authClusterRevokeInvite } from "../../funcs/authClusterRevokeInvite.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.RevokeClusterInviteRequest$inboundSchema,
};

export const tool$authClusterRevokeInvite: ToolDefinition<typeof args> = {
  name: "auth-cluster-revoke-invite",
  description: `Revoke a cluster invitation`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authClusterRevokeInvite(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
